const clone = (objToClone) => {
  return JSON.parse(JSON.stringify(objToClone));
};

const pivot = function(data) {
  // (c) https://gist.github.com/joyrexus/10222111#file-pivot-js
  var iter = function(pivoted, record) {
    for (var key in record) {
      if (!pivoted[key]) pivoted[key] = [];
      pivoted[key].push(record[key]);
    }
    return pivoted;
  };
  return data.reduce(iter, {});
};

const isUndefined = (v) => {
  return typeof v === 'undefined';
};

export { clone, pivot, isUndefined };



// WEBPACK FOOTER //
// ./src/utils/index.js